var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Index",attrs:{"data-component":"Index"}},[_c('functionality-are-temporarily-limited'),_c('first-page'),_c('what-system-can-do'),_c('about-applications'),_c('how-it-works'),(false)?_c('rates'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }